/* ============================================================
   宇治安シック 動的演出レイヤ v1（2026-07-06 碾茶室web）
   1) スクロール出現  2) 商品カード3Dチルト
   3) 茶葉の舞い（スライドショー上・ごく淡く）  4) 写真の視差
   すべて prefers-reduced-motion を尊重・タッチ端末ではチルト無効
   ============================================================ */
(function () {
  "use strict";
  document.documentElement.classList.add("uj-js");
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  /* ── 1) スクロール出現 ── */
  /* 注: transform で配置される要素（featured-slider__cover-content 等）は
     対象にしない — transform 上書きで位置ズレするため */
  var targets = [].slice.call(document.querySelectorAll(
    ".index-section .section-header, .index-section .card, .feature-row"
  ));
  targets.forEach(function (el, i) {
    el.classList.add("uj-rv");
    el.style.transitionDelay = ((i % 5) * 0.08) + "s";
  });
  if (reduced || !("IntersectionObserver" in window)) {
    targets.forEach(function (el) { el.classList.add("uj-in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("uj-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ── 2) 商品カードの3Dチルト（マウス環境のみ） ── */
  if (fine && !reduced) {
    [].slice.call(document.querySelectorAll(".card__wrapper")).forEach(function (card) {
      card.style.transition = "transform .18s ease-out, box-shadow .5s ease";
      card.addEventListener("pointermove", function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          "perspective(700px) rotateY(" + (x * 6).toFixed(2) + "deg) rotateX(" + (-y * 6).toFixed(2) + "deg) translateY(-4px)";
      });
      card.addEventListener("pointerleave", function () { card.style.transform = ""; });
    });
  }

  /* ── 3) 茶葉の舞い（スライドショーの写真の上に、ごく淡く） ── */
  var hero = document.querySelector('[data-section-type="slideshow-section"]');
  if (hero && !reduced) {
    var cv = document.createElement("canvas");
    cv.className = "uj-leaves";
    cv.setAttribute("aria-hidden", "true");
    cv.style.zIndex = "2";
    hero.appendChild(cv);
    var ctx = cv.getContext("2d");
    var W, H, dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var COLORS = ["rgba(246,241,228,", "rgba(203,178,126,", "rgba(126,154,85,"];
    var leaves = [];
    function resize() {
      W = hero.clientWidth; H = hero.clientHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      cv.style.width = W + "px"; cv.style.height = H + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function mk(init) {
      return {
        x: Math.random() * W,
        y: init ? Math.random() * H : -20,
        s: 5 + Math.random() * 7,
        sp: 0.18 + Math.random() * 0.34,
        ph: Math.random() * Math.PI * 2,
        rot: Math.random() * Math.PI,
        rsp: (Math.random() - 0.5) * 0.008,
        c: COLORS[(Math.random() * COLORS.length) | 0] + (0.10 + Math.random() * 0.10) + ")"
      };
    }
    function draw(l) {
      ctx.save();
      ctx.translate(l.x + Math.sin(l.ph) * 12, l.y);
      ctx.rotate(l.rot);
      ctx.beginPath();
      ctx.moveTo(0, -l.s);
      ctx.quadraticCurveTo(l.s * 0.75, 0, 0, l.s);
      ctx.quadraticCurveTo(-l.s * 0.75, 0, 0, -l.s);
      ctx.fillStyle = l.c;
      ctx.fill();
      ctx.restore();
    }
    var running = true;
    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      leaves.forEach(function (l) {
        l.y += l.sp; l.ph += 0.01; l.rot += l.rsp;
        if (l.y > H + 24) { var n = mk(false); for (var k in n) l[k] = n[k]; }
        draw(l);
      });
      requestAnimationFrame(tick);
    }
    resize();
    for (var i = 0; i < 10; i++) leaves.push(mk(true));
    window.addEventListener("resize", resize);
    document.addEventListener("visibilitychange", function () {
      running = !document.hidden;
      if (running) requestAnimationFrame(tick);
    });
    requestAnimationFrame(tick);
  }

  /* ── 4) 写真の視差（feature-row の画像） ── */
  if (!reduced) {
    var plx = [].slice.call(document.querySelectorAll(".feature-row__image"));
    if (plx.length) {
      var ticking = false;
      var frame = function () {
        ticking = false;
        var vh = window.innerHeight;
        plx.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var mid = r.top + r.height / 2 - vh / 2;
          el.style.transform = "translate3d(0," + (-mid * 0.05).toFixed(1) + "px,0)";
        });
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      onScroll();
    }
  }
})();
